import product from "../../images/product3.jpg";


//Events

//inagration

import i11 from "../../images/inagration/i11.jpg";
import i12 from "../../images/inagration/i12.jpg";
import i13 from "../../images/inagration/i13.jpg";
import i14 from "../../images/inagration/i14.jpg";
import i15 from "../../images/inagration/i15.jpg";
import i16 from "../../images/inagration/i16.jpg";
import i17 from "../../images/inagration/i17.jpg";
import i18 from "../../images/inagration/i18.jpg";
import i19 from "../../images/inagration/i19.jpg";
import i20 from "../../images/inagration/i20.jpg";
import i21 from "../../images/inagration/i21.jpg";

//events
import e10 from "../../images/flashmob/e10.jpg";
import e11 from "../../images/flashmob/e11.jpg";
import e12 from "../../images/flashmob/e12.jpg";
import e13 from "../../images/flashmob/e13.jpg";

//falshmob
import f1 from "../../images/flashmob/f1.jpg";
import f2 from "../../images/flashmob/f2.jpg";
import f3 from "../../images/flashmob/f3.jpg";
import f4 from "../../images/flashmob/f4.jpg";

//culturals
import c1 from "../../images/culturals/c1.jpg";
import c11 from "../../images/culturals/c11.jpg";
import c12 from "../../images/culturals/c12.jpg";
import c13 from "../../images/culturals/c13.jpg";
import c15 from "../../images/culturals/c15.jpg";

//workshops

import w6 from "../../images/workshops/w6.jpg";
import w10 from "../../images/workshops/w10.jpg";
import w11 from "../../images/workshops/w11.jpg";
import w12 from "../../images/workshops/w12.jpg";
import w13 from "../../images/workshops/w13.jpg";
import w14 from "../../images/workshops/w14.jpg";
import w15 from "../../images/workshops/w15.jpg";
import w16 from "../../images/workshops/w16.jpg";
import w17 from "../../images/workshops/w17.jpg";
import w18 from "../../images/workshops/w18.jpg";







export const galleryData = [
    {
        id: 1,
        title: "Inauguration-2k24",
        images: [i11, i12, i13, i14, i15, i16, i17, i18, i19, i20, i21]
    }
    ,
    {
        id: 2,
        title: "Workshops-2k24",
        images: [w10, w11, w12, w13, w14, w6, w15, w16, w17, w18]
    },
    {
        id: 4,
        title: "Events Culturals and Flashmob-2k24",
        images: [e10, e11, e12, e13, c1, c11, c12, c13, c15, f1, f2, f3, f4]
    },
    

    /*  {
         id: 5,
         title: "Processes",
         images: [product, product, product, product]
     },
     {
         id: 6,
         title: "Prototypes",
         images: [product, product, product, product]
     } */
];
